import className from 'classnames/bind';
import {Link} from "react-router-dom";
import LegalLayout from "~/features/Legal/components/LegalLayout";
import {LEGAL} from "~/features/Legal/legalConfig";
import style from '../style/Legal.module.scss';

const cn = className.bind(style);

const home = process.env.REACT_APP_HOMEPAGE || '';

/**
 * Chính sách bảo mật — trang CÔNG KHAI phục vụ Google OAuth verification.
 * Nội dung mục "Dữ liệu người dùng Google" bám theo yêu cầu của
 * Google API Services User Data Policy (khai báo scope, mục đích, lưu trữ,
 * chia sẻ, Limited Use, không train AI, cách thu hồi) — sửa cần đối chiếu policy.
 */
function PrivacyPolicy() {
	return (
		<LegalLayout title="Chính sách bảo mật">

			<p>
				Chính sách bảo mật này mô tả cách <strong>{LEGAL.appName}</strong> (truy cập tại{' '}
				<strong>{LEGAL.domain}</strong> — sau đây gọi là "chúng tôi", "dịch vụ") thu thập, sử dụng,
				lưu trữ và bảo vệ thông tin của bạn khi bạn sử dụng nền tảng phân tích &amp; tối ưu SEO của
				chúng tôi. Bằng việc sử dụng dịch vụ, bạn đồng ý với các nội dung trong chính sách này.
			</p>

			<h2>1. Thông tin chúng tôi thu thập</h2>
			<h3>a. Thông tin tài khoản</h3>
			<ul>
				<li>Họ tên, địa chỉ email, mật khẩu (được băm một chiều — chúng tôi không thể đọc mật khẩu gốc).</li>
				<li>Thông tin hồ sơ bạn tự cập nhật (ví dụ: số điện thoại, địa chỉ).</li>
			</ul>
			<h3>b. Dữ liệu bạn chủ động cung cấp khi dùng công cụ</h3>
			<ul>
				<li>Tên miền / URL website bạn muốn phân tích, cấu hình crawl, từ khoá theo dõi.</li>
				<li>Nội dung bạn nhập cho các tính năng AI (chủ đề, mô tả, câu hỏi cho trợ lý).</li>
				<li>Khoá API AI riêng (nếu bạn dùng gói yêu cầu khoá riêng) — được mã hoá khi lưu.</li>
			</ul>
			<h3>c. Dữ liệu thu thập tự động</h3>
			<ul>
				<li>Nhật ký đăng nhập và hoạt động (thời điểm, địa chỉ IP, hành động) — phục vụ bảo mật tài khoản.</li>
				<li>Kết quả phân tích do hệ thống tạo ra (điểm SEO, báo cáo crawl, số liệu hiệu năng).</li>
			</ul>

			<h2>2. Dữ liệu người dùng Google</h2>
			<h3>a. Đăng nhập bằng Google</h3>
			<p>
				Nếu bạn chọn đăng nhập/đăng ký bằng Google, chúng tôi chỉ nhận thông tin hồ sơ cơ bản từ Google:
				địa chỉ email, họ tên và ảnh đại diện — dùng duy nhất để tạo và đăng nhập tài khoản {LEGAL.appName}{' '}
				của bạn. Chúng tôi không truy cập danh bạ, hộp thư hay bất kỳ dữ liệu Google nào khác qua tính năng này.
			</p>
			<h3>b. Google Search Console &amp; Google Analytics</h3>
			<p>
				Khi bạn chủ động kết nối tài khoản Google với {LEGAL.appName} (tính năng Google Search Console
				và Google Analytics 4), chúng tôi truy cập dữ liệu Google của bạn thông qua cơ chế OAuth 2.0
				chính thức của Google, với các phạm vi (scope) <strong>chỉ đọc</strong> sau:
			</p>
			<ul>
				<li><code>https://www.googleapis.com/auth/webmasters.readonly</code> — đọc danh sách website và số liệu Search Console (lượt hiển thị, lượt nhấp, vị trí trung bình, trạng thái lập chỉ mục URL).</li>
				<li><code>https://www.googleapis.com/auth/analytics.readonly</code> — đọc danh sách property và số liệu Google Analytics 4 (phiên, người dùng, nguồn truy cập, trang, quốc gia, thiết bị).</li>
				<li>Địa chỉ email tài khoản Google — để hiển thị cho bạn biết đang kết nối bằng tài khoản nào.</li>
			</ul>
			<h3>Chúng tôi dùng dữ liệu này để làm gì</h3>
			<ul>
				<li>Hiển thị báo cáo hiệu suất tìm kiếm và lưu lượng truy cập <strong>cho chính bạn</strong>, bên trong các dự án của bạn.</li>
				<li>Tính toán các phân tích phái sinh phục vụ bạn: cơ hội từ khoá, theo dõi thứ hạng, phát hiện cannibalization, báo cáo email định kỳ (nếu bạn bật).</li>
			</ul>
			<h3>Lưu trữ</h3>
			<ul>
				<li>Token truy cập OAuth được <strong>mã hoá</strong> trước khi lưu vào cơ sở dữ liệu; chỉ hệ thống đồng bộ nền sử dụng được.</li>
				<li>Số liệu tổng hợp theo ngày (không phải nội dung email hay dữ liệu cá nhân khác của tài khoản Google) được lưu trong cơ sở dữ liệu của chúng tôi để hiển thị báo cáo nhanh mà không phải gọi Google lặp lại.</li>
			</ul>
			<h3>Chia sẻ</h3>
			<p>
				Chúng tôi <strong>không bán, không cho thuê, không chia sẻ</strong> dữ liệu Google của bạn cho bất kỳ
				bên thứ ba nào. Dữ liệu chỉ hiển thị cho tài khoản của bạn (và quản trị viên hệ thống khi bạn yêu cầu
				hỗ trợ kỹ thuật). Dữ liệu Google của bạn không được dùng cho quảng cáo.
			</p>
			<div className={cn('highlight')}>
				<p style={{marginBottom: 8}}>
					<strong>Cam kết Giới hạn sử dụng (Limited Use):</strong> việc {LEGAL.appName} sử dụng và chuyển
					giao thông tin nhận được từ Google API tuân thủ{' '}
					<a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer">
						Chính sách dữ liệu người dùng của Dịch vụ API Google (Google API Services User Data Policy)
					</a>, bao gồm các yêu cầu về Giới hạn sử dụng (Limited Use requirements).
				</p>
				<p style={{marginBottom: 0}}>
					Chúng tôi <strong>không</strong> sử dụng dữ liệu người dùng Google để phát triển, cải thiện hay
					huấn luyện các mô hình AI/máy học (generalized AI/ML models). Dữ liệu gửi tới nhà cung cấp AI
					(mục 4) chỉ gồm nội dung bạn chủ động nhập, không bao gồm dữ liệu lấy từ Google API.
				</p>
			</div>
			<h3>Thu hồi quyền truy cập</h3>
			<ul>
				<li>Trong {LEGAL.appName}: ngắt kết nối Google ở trang cài đặt của dự án — hệ thống ngừng đồng bộ.</li>
				<li>Từ phía Google: truy cập{' '}
					<a href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">myaccount.google.com/permissions</a>{' '}
					và gỡ quyền của {LEGAL.appName} — token bị vô hiệu ngay lập tức.</li>
				<li>Bạn có thể yêu cầu xoá toàn bộ dữ liệu Google đã đồng bộ bằng cách xoá dự án tương ứng hoặc liên hệ chúng tôi (mục 10).</li>
			</ul>

			<h2>3. Cách chúng tôi sử dụng thông tin</h2>
			<ul>
				<li>Cung cấp, vận hành và cải thiện các tính năng của dịch vụ.</li>
				<li>Xác thực đăng nhập, bảo vệ tài khoản, phát hiện truy cập bất thường.</li>
				<li>Gửi thông báo trong ứng dụng, thông báo đẩy và email (xác minh tài khoản, báo cáo định kỳ — email marketing chỉ khi bạn đồng ý, và bạn tắt được thông báo email bất cứ lúc nào).</li>
				<li>Thống kê sử dụng theo hạn mức gói dịch vụ (số URL kiểm tra, token AI…).</li>
			</ul>

			<h2>4. Chia sẻ dữ liệu với bên thứ ba</h2>
			<p>Chúng tôi không bán dữ liệu của bạn. Dữ liệu chỉ được gửi tới bên thứ ba trong các trường hợp sau:</p>
			<ul>
				<li><strong>Google APIs</strong> (PageSpeed Insights, Search Console, Analytics) — khi bạn dùng các tính năng tương ứng.</li>
				<li><strong>Nhà cung cấp AI</strong> (ví dụ Google Gemini, OpenAI-tương thích, Anthropic) — chỉ nội dung bạn chủ động nhập cho tính năng AI được gửi đi để sinh kết quả.</li>
				<li><strong>Nhà cung cấp gửi email</strong> — địa chỉ email của bạn, để gửi email giao dịch/báo cáo bạn yêu cầu.</li>
				<li><strong>Theo yêu cầu pháp luật</strong> — khi cơ quan có thẩm quyền yêu cầu hợp lệ.</li>
			</ul>

			<h2>5. Lưu trữ &amp; bảo mật</h2>
			<ul>
				<li>Mật khẩu được băm; token OAuth và khoá API riêng được mã hoá trước khi lưu.</li>
				<li>Phiên đăng nhập dùng JWT có thời hạn ngắn kèm refresh token; quản trị viên có thể buộc đăng xuất khi phát hiện bất thường.</li>
				<li>Truy cập dữ liệu được phân quyền theo vai trò; dữ liệu dự án chỉ hiển thị cho chủ sở hữu.</li>
				<li>Không có phương thức truyền tải/lưu trữ nào an toàn tuyệt đối — nếu phát hiện sự cố ảnh hưởng dữ liệu của bạn, chúng tôi sẽ thông báo trong thời gian sớm nhất.</li>
			</ul>

			<h2>6. Thời hạn lưu giữ &amp; xoá dữ liệu</h2>
			<ul>
				<li>Lịch sử phân tích (báo cáo SEO, crawl, AI…) được tự động dọn theo thời hạn lưu lịch sử của gói dịch vụ bạn dùng.</li>
				<li>Xoá dự án sẽ xoá dữ liệu crawl và dữ liệu Google đã đồng bộ thuộc dự án đó.</li>
				<li>Nếu một tính năng phụ thuộc nguồn dữ liệu bên thứ ba bị thay đổi hoặc ngừng cung cấp, dữ liệu đệm (cache) liên quan tới tính năng đó có thể bị xoá.</li>
				<li><strong>Xoá tài khoản:</strong> bạn có thể yêu cầu xoá toàn bộ tài khoản bất cứ lúc nào bằng cách liên hệ theo mục 10 (gửi từ email đã đăng ký). Sau khi xác minh, chúng tôi xoá tài khoản cùng dữ liệu cá nhân, dự án, kết nối và lịch sử liên quan trong tối đa <strong>30 ngày</strong> — trừ dữ liệu buộc phải lưu theo quy định pháp luật hoặc nhật ký bảo mật đã ẩn danh. Thao tác xoá là không thể khôi phục.</li>
			</ul>

			<h2>7. Cookie và lưu trữ cục bộ</h2>
			<p>
				Chúng tôi dùng bộ nhớ cục bộ của trình duyệt (localStorage) để giữ phiên đăng nhập (access token)
				và một số tuỳ chọn giao diện. Chúng tôi không dùng cookie theo dõi quảng cáo của bên thứ ba.
			</p>

			<h2>8. Quyền của bạn</h2>
			<ul>
				<li>Xem và cập nhật thông tin hồ sơ trong trang Tài khoản.</li>
				<li>Yêu cầu trích xuất hoặc xoá dữ liệu cá nhân.</li>
				<li>Ngắt kết nối Google, tắt thông báo email/đẩy bất cứ lúc nào.</li>
			</ul>

			<h2>9. Trẻ em</h2>
			<p>
				Dịch vụ dành cho người dùng từ đủ 16 tuổi trở lên. Chúng tôi không cố ý thu thập dữ liệu của trẻ em;
				nếu phát hiện, chúng tôi sẽ xoá ngay.
			</p>

			<h2>10. Liên hệ</h2>
			<p>
				Mọi câu hỏi về chính sách này hoặc yêu cầu liên quan tới dữ liệu cá nhân, vui lòng liên hệ:{' '}
				<a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
			</p>

			<h2>11. Thay đổi chính sách</h2>
			<p>
				Chúng tôi có thể cập nhật chính sách này; bản mới sẽ được đăng tại trang này kèm ngày hiệu lực mới.
				Thay đổi trọng yếu sẽ được thông báo trong ứng dụng hoặc qua email. Xem thêm{' '}
				<Link to={`${home}/terms`}>Điều khoản sử dụng</Link> của chúng tôi.
			</p>

		</LegalLayout>
	);
}

export default PrivacyPolicy;
